import { render, staticRenderFns } from "./delivery-point-dadata-cdek.vue?vue&type=template&id=876ebc02&scoped=true"
import script from "./delivery-point-dadata-cdek.vue?vue&type=script&lang=js"
export * from "./delivery-point-dadata-cdek.vue?vue&type=script&lang=js"
import style0 from "./delivery-point-dadata-cdek.vue?vue&type=style&index=0&id=876ebc02&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "876ebc02",
  null
  
)

export default component.exports